import { connect } from 'react-redux';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { getShopItemsStreamId } from '../../../../streams/shop';
import { ShopItemType } from '../../../../../types/shop';
import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';

import { isCurrentUserProfileOwner } from '../../../../selectors/users';

const mapStateToProps = state => {
  const streamId = getShopItemsStreamId(ShopItemType.PREMIUM_CONTENT);
  return {
    streamId,
    premiumContentDeviations: getDeviationsByIds(
      state,
      streamSelectors.getItems(state, streamId)
    ),
    hasMore: streamSelectors.hasMore(state, streamId),
    isFetching: streamSelectors.isFetching(state, streamId),
    isOwner: isCurrentUserProfileOwner(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchMore: () =>
      dispatch(
        withOffset.actions.fetch(
          getShopItemsStreamId(ShopItemType.PREMIUM_CONTENT)
        )
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
